import { createSelector } from 'reselect';
import { DEFAULT_SORT } from '../../constants/admin/tables';
import { get } from 'lodash';
import { preferencesSelector } from '../authentication';

// STATE SELECTORS
const tables = (state, props = {}) => state.admin.tables[props.tableIndex || 0] || {};
const model = (_, props = {}) => props.model;

export const currentPageSelector = createSelector(tables, t => t.currentPage);
export const resultsPerPageSelector = createSelector(tables, t => t.resultsPerPage);
export const totalPagesSelector = createSelector(tables, t => t.totalPages);
export const totalResultsSelector = createSelector(tables, t => t.totalResults);
export const dataSelector = createSelector(tables, t => t.data || []);
export const selectedSelector = createSelector(tables, t => t.selected || []);
export const isFetchingSelector = createSelector(tables, t => t.fetching);
export const isFetchedSelector = createSelector(tables, t => t.fetched);
export const isDisabledSelector = createSelector(tables, t => t.disabled);
export const filtersSelector = createSelector(tables, t => t.filters);

export const sortSelector = createSelector(tables, model, preferencesSelector, (t, m, prefs) => {
    const sortPref = get(prefs, `tables.${m}.sort`);
    if (sortPref) {
        return sortPref[0] === '-' ? sortPref.substring(1) : sortPref;
    }
    return t.sort || get(DEFAULT_SORT, `${m}.field`);
});

export const sortDirectionSelector = createSelector(tables, model, preferencesSelector, (t, m, prefs) => {
    const sortPref = get(prefs, `tables.${m}.sort`);
    if (sortPref) {
        return sortPref[0] === '-' ? '-' : '';
    }
    return t.sort ? t.sortDirection : get(DEFAULT_SORT, `${m}.direction`) || '';
});

export const searchQuerySelector = createSelector(tables, t => t.searchQuery);

export const selectedRowPublicUrlSelector = createSelector(tables, t => {
    if (t.selected.length === 1) {
        const selectedRow = t.selected[0];
        const rowData = t.data.find(el => el.id === selectedRow);
        return rowData.publicId
            ? `URL: ${window.location.origin}/review/${rowData.publicId} ${
                  rowData.pinCode ? `\n\n PIN: ${rowData.pinCode}` : ''
              }`
            : false;
    }
    return false;
});

export const selectedRowContractIdsSelector = createSelector(tables, t => {
    if (t.selected.length === 1) {
        const selectedRow = t.selected[0];
        const rowData = t.data.find(el => el.id === selectedRow);
        return { contractId: rowData.id, versionId: rowData.version.id };
    }
    return false;
});

export const canSendReminderSelector = createSelector(tables, t => {
    if (t.selected.length) {
        const mapping = t.data.filter(el => {
            const isSelected = t.selected.includes(el.id);
            const isSignedOrDraft = el.version ? el.version.state === 'signed' || el.version.state === 'draft' : false;
            return isSelected && isSignedOrDraft;
        });
        return !mapping.length;
    }

    return false;
});



// WEBPACK FOOTER //
// ./src/selectors/admin/tables.js